import { TranslationDictionary } from './types';

export const zhCN: TranslationDictionary = {
    common: {
        title: 'BimEngine',
        description: '这是一个使用 BIM-ENGINE。',
        openTestDialog: '打开测试弹窗',
        openInfoDialog: '打开信息弹窗 (封装版)',
    },
    toolbar: {
        home: '首页',
        measure: '测量',
        zoomBox: '选框放大',
        info: '信息',
        location: '定位',
        setting: '设置',
        walk: '漫游',
        map: '地图',
        property: '构件详情',
        fullscreen: '全屏',
        walkMenu: '漫游菜单',
        walkPerson: '第一人称',
        walkBird: '第三人称',
        tree: '模型树',
        section: '剖切',
        sectionPlane: '拾取面剖切',
        sectionAxis: '轴向剖切',
        sectionBox: '剖切盒',
        cameraSwitch: '相机切换',
    },
    dialog: {
        testTitle: '测试弹窗',
        testContent: '<div style="padding: 10px;">这是一个 <b>可拖拽</b> 且 <b>可缩放</b> 的弹窗。<br><br>你可以尝试拖动标题栏，或者拖动右下角改变大小。</div>',
    },
    menu: {
        info: '信息',
        home: '首页',
        componentDetail: '构件详情',
        hideSelected: '隐藏选中构件',
        transparentSelected: '半透明选中构件',
        cancelTranslucent: '取消半透明',
        isolateSelected: '隔离选中构件',
        hideOthers: '其他构件隐藏',
        transparentOthers: '其他构件半透明',
        fitSectionBox: '剖切盒适应',
        showAll: '显示全部',
        quickSelect: '快速选择',
        selectSameType: '选择同类模型',
        selectSameLevel: '选择同层模型',
        selectSameLevelType: '选择同层同类模型'
    },
    tree: {
        searchPlaceholder: '请输入要搜索的内容',
        noResults: '未找到匹配结果',
    },
    constructTree: {
        title: '目录树',
    },
    componentTreeDrawer: {
        actions: {
            close: '关闭抽屉',
            add: '新增',
            addPin: '新增图钉',
            addFolder: '新增文件夹',
            edit: '编辑',
            delete: '删除',
            save: '保存',
            cancel: '取消'
        },
        tabs: {
            view: '视图',
            pin: '图钉',
            constructTree: '构件树'
        },
        empty: {
            pinTitle: '暂无图钉',
            pinDesc: '点击上方按钮添加第一个图钉'
        },
        defaultNames: {
            pin: '图钉',
            folder: '文件夹'
        },
        dialogs: {
            noticeTitle: '提示',
            deleteFolderTitle: '删除文件夹',
            deleteFolderMessage: '确认删除该文件夹以及文件夹下面的所有图钉吗？',
            deleteFolderMessagePrefix: '是否删除【',
            deleteFolderMessageSuffix: '】文件夹以及文件夹下面所有的图钉数据。',
            confirm: '确定'
        },
        placeholders: {
            view: '视图页面占位，后续在这里接入视图相关内容。',
            pin: '暂无图钉，点击上方按钮添加',
            constructTree: '构件树页面占位，后续在这里接入新的构件树能力。'
        }
    },
    viewTab: {
        category: {
            ceilingPlans: '天花板平面',
            elevations: '立面',
            floorPlans: '楼层平面',
            sections: '剖面',
        },
        empty: '暂无视图数据',
        default3D: '默认三维',
    },
    tab: {
        component: '构件',
        system: '系统',
        space: '空间',
        type: '类型',
        major: '专业',
    },
    panel: {
        property: {
            title: '构件详情',
            base: '基本属性',
            material: '材质信息',
            advanced: '高级设置',
            tab: {
                props: '属性',
                material: '材质'
            }
        },
        componentDetail: {
            title: '构件详情',
            noSelection: '请先选中构件'
        }
    },
    measure: {
        btnName: '测量',
        dialogTitle: '测量',
        modes: {
            clearHeight: '净高',
            clearDistance: '净距',
            distance: '距离',
            elevation: '标高',
            point: '坐标',
            angle: '角度',
            area: '面积',
            slope: '坡度',
        },
        actions: {
            expand: '展开',
            collapse: '收起',
            clearAll: '删除全部',
            settings: '设置',
        },
        labels: {
            currentMode: '当前测量方式：',
            x: 'X：',
            y: 'Y：',
            z: 'Z：',
            value: {
                clearHeight: '净高：',
                clearDistance: '净距：',
                distance: '距离：',
                elevation: '标高：',
                point: '坐标：',
                angle: '角度：',
                area: '面积：',
                slope: '坡度：',
            }
        },
        settings: {
            title: '设置',
            unit: '单位：',
            precision: '精度：',
            hint: '距离、净距、净高和标高默认使用该单位；角度和面积有各自默认单位。',
            save: '保存设置',
            cancel: '取消',
        },
        clearHeight: {
            direction: '朝向：',
            directionDown: '朝下',
            directionUp: '朝上',
            selectType: '选择对象：',
            selectPoint: '选择点',
            selectElement: '选择构件',
        }
    },
    sectionPlane: {
        dialogTitle: '拾取面剖切',
        actions: {
            hide: '隐藏',
            reverse: '反向',
            reset: '重置',
            fill: '填充'
        }
    },
    sectionAxis: {
        dialogTitle: '轴向剖切',
        actions: {
            hide: '隐藏',
            reverse: '反向',
            reset: '重置',
            axisX: 'X',
            axisY: 'Y',
            axisZ: 'Z',
            fill: '填充'
        }
    },
    sectionBox: {
        dialogTitle: '剖切盒',
        actions: {
            hide: '隐藏',
            reverse: '反向',
            fitToModel: '适应',
            reset: '重置',
            fill: '填充'
        },
        axes: {
            x: 'X',
            y: 'Y',
            z: 'Z'
        }
    },
    walkControl: {
        speed: '移动速度：',
        gravity: '重力',
        collision: '碰撞',
        characterModel: {
            label: '建筑工人',
            constructionWorker: '建筑工人',
            officeMale: '办公室男性'
        },
        walkMode: {
            label: '行走模式',
            walk: '行走模式',
            run: '奔跑模式'
        },
        exit: '退出',
        path: {
            dialogTitle: '路径漫游',
            duration: '漫游时间',
            durationUnit: '秒',
            loop: '循环播放',
            addPoint: '添加漫游点',
            deleteAll: '删除全部',
            point: '漫游点',
            play: '播放漫游',
            stop: '停止漫游',
            noPoints: '暂无漫游点，请添加'
        }
    },
    info: {
        dialogTitle: '基本信息',
        meshCount: '构件数量',
        totalTriangles: '三角面数量',
        totalVertices: '顶点数量',
    },
    aiChat: {
        title: 'AI 助手',
        placeholder: '输入你的问题...',
        quickPrompt: {
            summarize: '总结这个模型',
            explain: '解释选中的构件',
            generate: '生成报告'
        },
        action: {
            new: '新建对话',
            history: '历史记录',
            settings: '设置',
            close: '关闭'
        },
        helper: {
            newline: 'Shift + Enter 换行',
            send: 'Enter 发送'
        },
        thinking: '正在思考...',
        other: '其他',
        otherPlaceholder: '请输入自定义答案',
        submit: '提交'
    },
    viewDropdown: {
        triggerTitle: '视图控制',
        switchOrthographic: '切换到正交视图',
        switchPerspective: '切换到透视视图',
        saveMainView: '将当前视图设为主视图',
        restoreMainView: '重置主视图',
        captureScreenshot: '截图保存',
    },
    setting: {
        dialogTitle: '设置',
        presetSelect: '选择预设',
        presetSelectPlaceholder: '请选择预设',
        defaultPresetLabel: '默认预设',
        savePreset: '保存预设',
        deletePreset: '删除预设',
        deletePresetForbidden: '默认预设不允许删除',
        presetDefaultName: '预设',
        presetNamePrompt: '请输入预设名称',
        presetNameRequired: '预设名称不能为空',
        presetNameDuplicate: '预设名称已存在，请使用其他名称',
        restorePreset: '恢复预设',
        saveAsNewPreset: '存为新预设',
        selectPresetFirst: '请先选择预设',
        presetButton: '预设',
        undoChanges: '撤销修改',
        saveAsDialogTitle: '存为新预设',
        deleteDialogTitle: '删除预设',
        deleteDialogMessage: '确认删除当前预设吗？删除后不可恢复。',
        presetNamePlaceholder: '请输入预设名称',
        confirm: '确定',
        cancel: '取消',
        presetPickPrompt: '请输入预设序号',
        presetPickInvalid: '预设序号无效',
        renderMode: '渲染模式',
        modes: {
            simple: '性能模式',
            balance: '平衡模式',
            advanced: '效果模式',
        },
        displaySection: '显示设置',
        edgeLine: '边线',
        edgeOpacity: '边线透明度',
        showGrid: '显示轴网',
        showLevel: '显示标高',
        contrast: '对比度',
        saturation: '饱和度',
        lightIntensity: '光照强度',
        environment: '环境背景',
        environmentType: {
            none: '无',
            hdr: 'HDR背景',
            sky: '天空盒',
        },
        backgroundVisible: '显示背景',
        ground: '显示地面',
        groundElevation: '地面高度',
        groundElevationUnit: 'm',
    },
    help: {
        engineControl: '引擎控制',
        fpsControl: '第一视角控制',
        gotIt: '好的，知道了',
        dontRemind: '不再提醒我',
        rotate: '旋转',
        mouseLeftDrag: '鼠标左键拖拽',
        pan: '平移',
        shiftLeftDrag: 'Shift + 左键 / 右键拖拽',
        zoom: '缩放',
        mouseWheel: '鼠标滚轮',
        boxSelect: '框选',
        ctrlLeftDrag: 'Ctrl + 左键拖拽',
        multiSelect: '加选 / 减选',
        ctrlShiftClick: 'Ctrl + 单击 (加) / Shift + 单击 (减)',
        homeView: '回到主视图',
        doubleClickBlank: '双击空白区域',
        rotateRuleTitle: '旋转点变换规则',
        rotateRuleDesc: '鼠标悬停构件时，按当前位置设定旋转中心；悬停空白区域时，保持上一次旋转中心。',
        roam: '漫游',
        or: '或',
        upDown: '向上和向下移动',
        qeKey: 'Q / E',
        landOnFloor: '开启重力将落在最近楼层',
        run: '运行 (加速)',
        shiftArrow: 'Shift + 方向键',
        teleport: '传送',
        doubleClick: '双击目标',
        lookAround: '环视',
        leftDrag: '使用左键拖动视图',
        adjustSpeed: '调整速度',
        rotateView: '旋转视图',
        panView: '平移视图',
        zoomView: '缩放视图',
        resetView: '视图复位',
        mouseLeftDragShort: '鼠标左键拖拽',
        mouseRightDragShort: '鼠标右键拖拽/Shift+左键',
        mouseWheelShort: '滚动鼠标滚轮',
        componentSelect: '构件选择',
        click: '单击',
        addSelect: '加选构件',
        removeSelect: '减选构件',
        doubleClickBlankShort: '双击空白区域',
        pointToComponent: '指向构件：',
        pointToComponentDesc: '以鼠标点击位置为旋转中心',
        pointToBlank: '指向空白：',
        pointToBlankDesc: '保持上一次确定的旋转中心',
        roamMove: '漫游移动',
        roamMoveDesc: '使用 WASD 键进行移动',
        speedUp: '加速移动',
        lookAroundDesc: '左键拖动视图查看四周',
        teleportDesc: '双击目标构件或地面',
    }
};
